// src/services/settingsService.js
// Lecture publique des paramètres (mode de paiement par service) pour les pages client.

const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.VITE_API_BASE_URL ||
  "https://nouzhaback-theta.vercel.app";

const DEFAULT_MODES = {
  circuit: "direct",
  hotel: "direct",
  transport: "email",
  visite: "email",
  voiture: "email",
};

// Cache partagé du fetch des settings publics (évite N requêtes si plusieurs
// composants les demandent). Rafraîchi à chaque rechargement de page.
let _publicSettingsPromise = null;
function fetchPublicSettings() {
  if (!_publicSettingsPromise) {
    _publicSettingsPromise = fetch(`${API_BASE}/api/settings/public`, { credentials: "include" })
      .then((r) => r.json())
      .then((d) => d?.data || {})
      .catch(() => ({}));
  }
  return _publicSettingsPromise;
}

/**
 * Les fonctionnalités IA (dictée vocale) sont-elles activées ?
 * Désactivées par défaut (false) tant que l'admin ne les active pas.
 */
export async function getAiEnabled() {
  try {
    const data = await fetchPublicSettings();
    return data?.aiEnabled === true;
  } catch {
    return false;
  }
}

/**
 * Récupère le mode de paiement d'un service ("direct" | "email").
 * En cas d'erreur réseau, retombe sur la valeur par défaut.
 */
export async function getPaymentMode(service) {
  try {
    const res = await fetch(`${API_BASE}/api/settings/public`, { credentials: "include" });
    const data = await res.json();
    const modes = data?.data?.paymentMode || {};
    return modes[service] || DEFAULT_MODES[service] || "direct";
  } catch {
    return DEFAULT_MODES[service] || "direct";
  }
}

export async function getAllPaymentModes() {
  try {
    const res = await fetch(`${API_BASE}/api/settings/public`, { credentials: "include" });
    const data = await res.json();
    return { ...DEFAULT_MODES, ...(data?.data?.paymentMode || {}) };
  } catch {
    return { ...DEFAULT_MODES };
  }
}

const settingsService = { getPaymentMode, getAllPaymentModes, getAiEnabled };
export default settingsService;
